import type { Routes } from '@angular/router';
import { permissionGuard } from '../../../auth/common/guards/permission.guard';

export const INTEGRATIONS_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./integrations/integrations.component').then(
        (m) => m.IntegrationsComponent,
      ),
    canActivate: [permissionGuard('integrations.get')],
  },
] as const;
